/* eslint-disable simple-import-sort/imports */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Import design system styles FIRST, before our local Tailwind utilities index.css
import { ensureDesignSystemTokens } from "./design-system.ts";

import "@/i18n";
import "./index.css";

import { initMixpanel } from "@prophero-customers/analytics";
import App from "./App.tsx";
function initializeApp() {
  /**
   * ACUL Integration Note:
   * The following lines handle the specific way this React application is integrated
   * into Auth0's Universal Login page. Auth0 provides the base HTML DOM.
   * This script then creates a 'div' (rootElement),
   * appends it to Auth0's document.body, and then mounts the React application onto this div.
   * This differs from typical setups where an index.html is bundled directly with the app.
   */
  const rootElement = document.createElement("div");
  rootElement.id = "root";

  document.body.appendChild(rootElement);

  // Ensure DS CSS variables are available globally before rendering
  ensureDesignSystemTokens();
  initMixpanel(import.meta.env.VITE_MIXPANEL_TOKEN ?? "", import.meta.env.DEV);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

initializeApp();
